import { Component, EventEmitter, Input, Output } from "@angular/core";

export interface BodyInterface {
  iconColor?: string;
  icon?: string;
  description?: string;
  value?: string;
}

@Component({
  selector: "bfd-card-value",
  templateUrl: "./bfd-card-value.component.html",
  styleUrls: ["./bfd-card-value.component.scss"],
})
export class CardValueComponent {
  @Input() notice?: string;
  @Input() title?: string;
  @Input() body?: BodyInterface[] = [];
  @Input() button?: string;
  @Output() clikedEmitter: EventEmitter<boolean> = new EventEmitter<boolean>();

  public action() {
    this.clikedEmitter.emit(true);
  }

  public isNumber(value: any): boolean {
    return typeof value === "number";
  }
}
